module.exports = __webpack_public_path__ + "static/media/menuRole.9e3d573d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuRole.svg
// module id = 481
// module chunks = 0